module.exports = __webpack_public_path__ + "static/media/stress.c9098c93.png";